import React, {ReactNode} from "react";
import {
    Resource,
    ResourceType,
    resourceTypeIconMap,
    resourceTypeIconMapBig
} from "../../models/resource";
import {Avatar, Box, Button, Card, Chip, IconButton, Stack, Typography} from "@mui/joy";
import {
    Archive,
    Book,
    BookmarkIcon, BookOpen,
    Download,
    Eye, EyeIcon,
    File, FileText,
    HandPlatter, LayoutTemplate,
    Lightbulb, Map,
    Speaker,
    StarIcon,
    User, Volume
} from "lucide-react";
import {useSearchParams} from "react-router-dom";
import {useUITheme} from "../../hooks/useUITheme";
import {clampLines} from "../../utils/textClamp";

type ResourceItemComponentProps = {
    resource?: Resource,
}

const ResourceLibraryItemComponent = (props: ResourceItemComponentProps) => {
    const [searchParams, setSearchParams] = useSearchParams()

    const handleViewResource = () => {
        const urlSearchParams = new URLSearchParams(searchParams)
        urlSearchParams.set("resourceId", props.resource.id)
        urlSearchParams.set("view", "resource")
        setSearchParams(urlSearchParams)
    }

    return <Card onClick={handleViewResource}
                 sx={{
                     padding: 3,
                     cursor: "pointer",
                     transition: "transform 0.3s ease",
                     minWidth: 0,
                 }}>

        <Stack gap={2}>
            <Box data-accent width={"max-content"} display={"flex"}
                 alignItems="center"
                 padding={1} height={"max-content"} sx={{
                bgcolor: "primary.softBg",
                color: "primary.softColor"
            }} borderRadius={10}>
                {resourceTypeIconMapBig[props.resource.type]}
            </Box>

            <Stack gap={2} justifyContent={"space-between"} minWidth={0}>
                <Typography level={"title-md"} title={props.resource.title} sx={clampLines(2)}>
                    {props.resource.title}
                </Typography>

                <Stack gap={1} direction={"row"} alignItems={"center"} flexWrap={"wrap"}>

                    <Chip color={"warning"}>
                        {props.resource.type}
                    </Chip>

                    {props.resource.examRelevance?.map(exam =>
                        <Chip color={"primary"}>
                            {exam}
                        </Chip>)}
                </Stack>

                <Typography color={"neutral"}>
                    {props.resource.content.substring(0, 20)}
                </Typography>

                <Stack gap={2} direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                    <Typography startDecorator={<StarIcon color={'gold'} fill={'gold'}/>} level={"title-lg"}>
                        {(props.resource.rating || 0).toFixed(1)}
                    </Typography>

                    <Typography color={"neutral"} startDecorator={<EyeIcon style={{color: "inherit"}}/>}
                                level={"title-lg"}>
                        {props.resource.readCount || 0}
                    </Typography>

                </Stack>

            </Stack>
        </Stack>


    </Card>
}

export default ResourceLibraryItemComponent